import React from 'react';
import MeetingDetailsNavigation from './Navigation/MeetingDetailsNavigation';

interface IMeetingNotAvailableMessageProps {
  showTopNavBtns?: boolean;
  agendaLabel?: string;
}

const MeetingNotAvailableMessage: React.FC<IMeetingNotAvailableMessageProps> = ({
  showTopNavBtns,
  agendaLabel,
}): JSX.Element => {
  return (
    <div className='md:w-3/4 w-100'>
      <div className={`shadow-gray bg-white mx-auto md:px-8 px-0 p-8 mt-12`}>
        <MeetingDetailsNavigation
          showTopNavBtns={showTopNavBtns}
          agendaLabel={agendaLabel}
        />

        <div className='meeting-wrapper flex flex-col items-center justify-center min-h-24rem p-8 max-h-full min-h-200'>
          <div className='text-center'>
            <h2 className='text-2x1 font-size-18px font-semibold mb-4'>
              This meeting is not currently available
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingNotAvailableMessage;
